var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-edit",on:{"!click":function($event){return _vm.toolHandler($event)}}},[_c('div',{staticClass:"toolbar",class:{'block-active': _vm.isActive}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
export { render, staticRenderFns }


// WEBPACK FOOTER //
// ./src/components/BoxForm/BoxForm.vue